import { FORM_SHARE_TRACKED_CHANNELS } from '@components/share-form/constants';

import { UpdateFormSourcesResponse } from '../types';
import { UpdateFormSourcesApiResponse } from '../types/formSourceApi';
import { mapFormShareLinksApi } from './mapFormShareLinksApi';

const DEFAULT_SOURCE_LABELS = new Set(
  FORM_SHARE_TRACKED_CHANNELS.map((channel) => channel.label.toLowerCase())
);

const DEFAULT_SOURCE_NAMES = new Set(
  FORM_SHARE_TRACKED_CHANNELS.map((channel) => channel.utmSource.toLowerCase())
);

export const validateFormCustomSource = (
  label: string,
  name: string
): string | null => {
  const trimmedLabel = label.trim();
  const trimmedName = name.trim();

  if (!trimmedLabel) {
    return 'Source name is required';
  }
  if (!trimmedName) {
    return 'URL tag is required';
  }
  if (DEFAULT_SOURCE_LABELS.has(trimmedLabel.toLowerCase())) {
    return 'Source name cannot match a default source';
  }
  if (DEFAULT_SOURCE_NAMES.has(trimmedName.toLowerCase())) {
    return 'URL tag cannot match a default source';
  }

  return null;
};

export const mapUpdateFormSourcesResponse = (
  response: UpdateFormSourcesApiResponse
): UpdateFormSourcesResponse => ({
  enable: response.enable,
  sources: mapFormShareLinksApi(response.sources)
});
